export default __webpack_public_path__ + "static/media/36I-114281_-20912_0.b950d23d.jpg";